<template>
  <div>
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <div>
      <PageTitle pageHeading="Tags" :rightsideButton="true">
        <v-btn
          id="toggle-tag-drawer"
          dark
          class="font-weight-bold px-2"
          @click="toggleTagDrawer"
        >
          <span class="pl-2 pr-3"> NEW TAG </span>
        </v-btn>
      </PageTitle>

      <CreateUpdate
        ref="tagDrawer"  
        :action="action" 
        :name="tagName" 
        :id="tagId" 
        @create="newTag"
        @tag="getTagName"/>

      <DeleteConfirmation  
        ref="tagDelete"
        :name="tagName" 
        :id="tagId" 
        @getTag="getTagList"/>

      <v-data-table
        :headers="headers"
        :items="tagList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        class="elevation-1 mt-8"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100],
        }"
        :mobile-breakpoint="960"
        :items-per-page="perPage"
        :loading="loading"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name.length > 32 ? item.name.substring(0, 32) + '...' : item.name| upperCaseFirst}}
        </template>
        <template v-slot:[`item.CreatedAt`]="{ item }">
          {{ item.created_at | formatDate}}
        </template>
        <template v-slot:[`item.UpdatedAt`]="{ item }">
          {{ item.updated_at | formatDate}}
        </template>
        <template v-slot:[`item.action`]="{ item }">
            <v-menu offset-y left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon class="font-weight-bold">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense class="pa-0">
                <v-list-item-group>
                  <v-list-item
                    id="edit-template"
                    link
                    @click="singleItem(item)"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon size="20"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-regular"
                        >Edit</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    id="delete-template"
                    link
                    @click="toggleDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon size="20">delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-regular"
                        >Delete</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/components/shared/PageTitle.vue";
import PlaceHolders from "@/components/settings/reply_templates/Placeholders.vue";
import DeleteConfirmation from "@/components/tags/DeleteConfirmation.vue"
import CreateUpdate from "@/components/tags/CreateUpdate.vue"
import { $tag } from "@/services/Index";
import { formatDate } from "@/filters";

export default {
  name: "tag-index",
  components: {
    PageTitle,
    PlaceHolders,
    CreateUpdate,
    DeleteConfirmation,
  },
  data: () => {
    return {
      breadcrumbsList: [
        {
          text: "Settings",
          disabled: false,
          path: "settings",
        },
        {
          text: "Tags",
          disabled: true,
          path: "",
        },
      ],
      headers: [
        {
          text: " Name",
          align: "left",
          width: "50%",
          value: "name",
          sortable: false
        },
        {
          text:"Created At",
          align:"left",
          width:"20%",
          value:"CreatedAt",
          sortable: false
        },
        {
          text:"Updated At",
          align:"left",
          width:"20%",
          value:"UpdatedAt",
          sortable: false
        },
        {
          text: "Actions",
          value: "action",
          align: "right",
          width:"10%",
          sortable: false,
        },
      ],
      perPage: 10,
      page: 1,
      totalItems: 0,
      pagination: {},
      loading: false,
      action: "new",
      tagList: [],
      tagName: null,
      tagId: null,
      globalSearchKeyword: "",
    };
  },

  mounted(){
    this.getTagList();
  },

  watch: {
    pagination: {
      handler(newVal, oldVal) {
        if (oldVal.itemsPerPage) {
          this.getTagList();
        }
      },
      deep: true,
    },

    $route: {
      handler: function (to, from) {
        this.globalSearchKeyword = "";
        let name = to.query.name;
        if (name) {
          this.globalSearchKeyword = name;
          this.getTagList();
        } else {
          this.getTagList();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods:{
    toggleTagDrawer() {
      this.$refs.tagDrawer.drawer=true;
      this.action = "new";
      this.tagName = null;
      this.tagId = null;
    },
    async singleItem(data) {
      this.$refs.tagDrawer.drawer=true;
      this.action = "edit";
      this.tagName = data.name;
      this.tagId = data.id;
    },
    toggleDeleteDialog(data) {
      this.$refs.tagDelete.deleteDialog = true;
      this.tagName = data.name;
      this.tagId = data.id;
    },
    async getTagList(searchVal= "") {
      this.loading = true;
      const { page, itemsPerPage} = this.pagination;
      const data = {
        page,
        per_page: itemsPerPage,
        q: {
          name:searchVal,
          m: "or",
        },
      };
      try {
        const response = await $tag.fetchList(data, {});
        if (response.data) {
          this.totalItems = response.data.pagination.total_count;
          this.tagList = response.data.tag;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    getTagName(data){
      this.tagName = data;
    },
    async newTag() {
      let payload = {
                        tag: {
                            name: this.tagName
                        }
                    };
      let config = {};
      this.loading = true;
      if (this.action == "new") {
        $tag.create(payload,config).then((response)=>{
          this.$store.dispatch("ui/snackbar", [
              {
                title: "New Tag",
                message: `A New Tag has been created`,
                type: "success",
              },
            ]);
            this.getTagList();
            this.$refs.tagDrawer.drawer = false;
            this.loading = false;
        }).catch((error)=>{
          this.$refs.tagDrawer.drawer = false;
          this.loading = false;
          this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
        })
      } else {
          $tag.update(this.tagId, payload).then((response)=>{
            this.$store.dispatch("ui/snackbar", [
                {
                  title: "New Tag",
                  message: `A New Tag has been created`,
                  type: "success",
                },
              ]);
              this.getTagList();
              this.$refs.tagDrawer.drawer = false;
              this.loading = false;
          }).catch((error)=>{
            this.$refs.tagDrawer.drawer = false;
            this.loading = false;
            this.$store.dispatch("ui/snackbar", [
                {
                  title: "Error",
                  message: this.$errors(error.response.data).msg({
                    capitalize: false,
                    prepend: `${this.$errors(
                      error.response.data
                    ).subjectText()} `,
                  }),
                  type: "error",
                },
              ]);
          })
        }
    },
  },
}
</script>